<template>
    <li
        class="export-item"
    >
        <div class="export-content-container">
            <p>
                <CompassIconButton icon="download" :size="CompassEnums.IconButtonSize.MEDIUM" :disabled="item.status != 'succeed' || !item.public_url" @click="download" />
                <span class="export-item-name">&nbsp;{{ name }}</span>
            </p>
        </div>

        <div class="export-progress-container">
            <ExportProgressColumn :status="item.status" :progress="item.progress" :started_at="startedAt" />
        </div>
    </li>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import type { Translator } from 'js/shims-vue';
import useListingNames from 'vcomponents/listing/apiListing/mapping/ListingNames';
import ExportProgressColumn from 'vcomponents/listing/tableColumns/ExportProgressColumn.vue';

const $t = inject('$t') as Translator;

const ListingNames = useListingNames();

const props = defineProps({
    item: {
        type: Object,
        required: true,
        default: () => {},
    },
});

const name = computed(() => {
    let name = '';
    if (props.item['custom_name']) {
        name = props.item['custom_name'];
    } else {
        const date = window.sellsyapp.config.globalProperties.$filters.dateFormatter(props.item['created_at'], 'SLASHED_DATE_TIME', false);
        const listingName = ListingNames[props.item['listing_name']] !== undefined ? ListingNames[props.item['listing_name']].toLowerCase() : props.item['listing_name'];
        name = $t.__('export.notifications.exportName', { type: listingName, date });
    }
    return name;
});

const startedAt = computed(() => {
    return props.item.started_at ? moment(props.item.started_at) : null;
});

const download = () => {
    if (props.item.status === 'succeed' && props.item.public_url) {
        window.open(props.item.public_url, '_blank');
    }
};
</script>

<style scoped lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.export-item {
    border-radius: var(--spacing-0);
    padding: var(--spacing-2);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    p {
        margin: 0;
        line-height: 20px;
        font-size: 14px;
        text-align: left;
        word-break: break-word;
        display: flex;
        align-items: center;
    }

    .export-item-name {
        max-width: 300px;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: var(--font-weights-lato-1);
    }

    .export-content-container {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
    }

    .export-progress-container {
        display: flex;
        gap: var(--spacing-1);
        height: var(--spacing-5);
    }
}
</style>
